import React from "react";
import { Box, Container, Typography } from "@mui/material";
import backgroundImage from "../Assets/background3.png";
import logo from "../Assets/natureall-nb.png";

export default function Header() {
  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        py: { xs: 8, sm: 6, md: 10 },
        pb: { xs: 2, sm: 6, md: 2 },
        textAlign: "center",
        height: { xs: "auto", md: 180 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container maxWidth="md">
        <img
          src={logo}
          alt="NatureAll Logo"
          style={{
            width: "100%",
            maxWidth: "400px",
            marginBottom: "0px",
            marginTop: "-60px",
            objectFit: "contain",
          }}
        />
      </Container>
    </Box>
  );
}
